import { reduce } from 'lodash';
import { useMemo } from 'react';
import { Dayjs } from 'dayjs';
import { USA_DATE } from '../../../../constants/timeFormat';
import { BPTableDataType } from '../../type/BPTypes';
import { MeasurementHelper } from '../../helper/MeasurementHelper';
import { Measurement } from '../../../../uc-api-sdk';
import { MeasurementType } from '../../type/MeasurementTypes';
import { BPMeasurementService } from '../../helper/BPMeasurementService';

export const useBPResultToTable = (
  data: Measurement[],
  fromDate: Dayjs,
  toDate: Dayjs,
) => {
  const processedData = useMemo(() => {
    // create a table with date as the key and array of measurements as the value
    const dateValueDict = MeasurementHelper.dateValueDict(
      data as MeasurementType[],
    );

    // uses the table above to a the date create a
    // new table mealType as the key and array of measurements
    // as the value
    const getData = (date: string) => {
      const valuesInDay = dateValueDict[date];
      if (!valuesInDay) {
        return {};
      }
      const unsortedObject = reduce(valuesInDay, (res, curr) => {
        const timeOfDay = curr.timeOfTheDay;
        if (res[timeOfDay] === undefined) {
          res[timeOfDay] = [];
        }
        res[timeOfDay]?.push(new BPMeasurementService(curr));
        return res;
      }, {} as BPTableDataType['data']);

      return MeasurementHelper.sortByDate(unsortedObject);
    };

    return MeasurementHelper.createArrayOfDateData(
      fromDate,
      toDate,
      (date: Dayjs) => getData(date.format(USA_DATE)),
    ).reverse();
  }, [data, fromDate, toDate]);

  return processedData;
};
